import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'

export const OauthLayout = observer(() => {
  return <Outlet />
})
